import{useRef as n,useEffect as r}from"react";var t=function(t,e,o){var u=n(e);r(function(){u.current=e},[e]),r(function(){var n=function(n){u.current(n)};return o.addEventListener(t,n),function(){o.removeEventListener(t,n)}},[t,o])};export{t as default};
//# sourceMappingURL=index.js.map
